import {chain}       from "../../utils/fs";
import {paddingLeft} from "../../utils/strings";

export const formatTime11 = ({hour, minute}) => {
    return paddingLeft(chain(hour >= 12 ? hour-12 : hour, (_) => _ === 0 ? 12 : _)) + ":" + paddingLeft(minute) + " " + (hour < 12 ? "am" : "pm");
};
